import CustomDnsBinding from 'mbs-ui-shared@models/CustomDnsBinding';
import CustomDnsCertificate from 'mbs-ui-shared@models/CustomDnsCertificate';
import { ActionCreator, MemoizedSelector } from '@ngrx/store';
import { TypedAction } from '@ngrx/store/src/models';
import { EntityStateModel } from '../pagingStoreFactory/pagingStoreTypes';
import { StoreTypes } from '../storeTypes.enum';

export type CustomDnsBindingStoreProperties = {
  certificates: CustomDnsCertificate[];
  loadedCertificates: boolean;
  loadingCertificates: boolean;
};

export enum DnsBindingStoreCustomActionsTypes {
  loadCertificates = `Load Certificates`,
  setCertificates = `Set Certificates`
}

export type DnsBindingStoreCustomActionsType = `[${StoreTypes}] ${DnsBindingStoreCustomActionsTypes}`;

export type DnsBindingCustomActionTypes = {
  loadCertificates: ActionCreator<
    DnsBindingStoreCustomActionsType,
    (props: { force?: boolean }) => { force?: boolean } & TypedAction<DnsBindingStoreCustomActionsType>
  >;
  setCertificates: ActionCreator<
    DnsBindingStoreCustomActionsType,
    (props: {
      certificates: CustomDnsCertificate[];
    }) => { certificates: CustomDnsCertificate[] } & TypedAction<DnsBindingStoreCustomActionsType>
  >;
};

export type DnsBindingCustomSelectorTypes = {
  selectCertificates: MemoizedSelector<EntityStateModel<CustomDnsBinding, CustomDnsBindingStoreProperties>, CustomDnsCertificate[]>;
  selectLoadedCertificates: MemoizedSelector<EntityStateModel<CustomDnsBinding, CustomDnsBindingStoreProperties>, boolean>;
  selectLoadingCertificates: MemoizedSelector<EntityStateModel<CustomDnsBinding, CustomDnsBindingStoreProperties>, boolean>;
};
